import React, {
  FC,
  TextareaHTMLAttributes,
  useEffect,
  useRef,
  useState,
  useCallback,
} from 'react';
import { useField } from '@unform/core';

import { Container } from './styles';

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  name: string;
  padding?: string;
  height?: string;
  error?: string;
}

const Textarea: FC<TextAreaProps> = ({
  name,
  padding,
  height,
  error: errorData,
  className,
  ...rest
}) => {
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const [isFocuses, setIsFocuses] = useState(false);
  const [isFilled, setIsFilled] = useState(false);
  const { fieldName, defaultValue, error, registerField } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  const handleTextareaFocus = useCallback(() => {
    setIsFocuses(true);
  }, []);

  const handleTextareaBlur = useCallback(() => {
    setIsFocuses(false);
    setIsFilled(!!inputRef.current?.value);
  }, []);

  return (
    <>
      <Container
        className={`${isFocuses ? 'focuses ' : ''}${isFilled ? 'filled ' : ''}${
          error ? 'errored ' : ''
        }position-relative ${className}`}
        padding={padding}
        height={height}
        isErrored={!!error}
        isFilled={isFilled}
        isFocuses={isFocuses}
      >
        <textarea
          onFocus={handleTextareaFocus}
          onBlur={handleTextareaBlur}
          defaultValue={defaultValue}
          ref={inputRef}
          {...rest}
        />
      </Container>
      {(errorData || error) && (
        <span className="error small text-danger position-absolute w-100">
          {errorData || error}
        </span>
      )}
    </>
  );
};

export default Textarea;
